import * as React from 'react';
import { getIsDarkTheme } from 'owa-fabric-theme';
import classNames from 'classnames';

export function useModeStyles(getClass: (string) => string | undefined) {
    const getModeAwareClass: (string) => string | undefined = React.useCallback(
        (className: string) => {
            return classNames(getClass(className), getIsDarkTheme() && getClass('dark'));
        },
        [getClass]
    );

    return { getModeAwareClass };
}
